import DateRangePicker from "../../admin/dashboard/components/DateRangePicker";
import { MultiSelectDropdown } from "../../../components";
import CompaniesDropdown from "../../../components/CompaniesDropdown";
import Constants from "../../../Constants";
import { COMPANY_STATUS_MAP } from "@demandproai/shared";
import ResetFilterIcon from '../../../assets/icons/ResetFilterIcon.svg?react';
import DashboardFilterIcon from '../../../assets/icons/DashboardFilterIcon.svg?react';
import OpenFilterIcon from '../../../assets/icons/OpenFilterIcon.svg?react';
import useCompanyForm from "../../../hooks/useCompanyForm";
import { useCompanyFilterContext } from "./context/CompanyFilterContext";

const filterWrapperClasses = "ml-auto";
const filterContainerClasses = "flex items-center";
const filterToggleClasses = "cursor-pointer whitespace-nowrap flex items-center";
const filterTextClasses =
    "text-primary text-center font-['Source_Sans_Pro'] text-base font-semibold not-italic leading-6";
const filterContentClasses = "flex gap-4 ml-5";
const resetFilterClasses =
    "text-primary text-center font-['Source_Sans_Pro'] text-base font-semibold " +
    "not-italic leading-6 cursor-pointer";

const CompanyFilters = () => {
    const { superAdmin } = useCompanyForm();

    const {
        filterParams,
        filterConfig,
        isFilterOpen,
        isAnyFilterApplied,
        setIsFilterOpen,
        setSelectedTiers,
        setSelectedStatus,
        setSelectedCompanies,
        setSelectedAccountExecutive,
        setSelectedRange,
        resetFilters,
        selectedRange,
    } = useCompanyFilterContext();

    const companyStatusOptions = Object.values(COMPANY_STATUS_MAP);

    const { selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;

    return (
        <div className={filterWrapperClasses}>
            <div className={filterContainerClasses}>
                <div className={`${filterToggleClasses} ${filterTextClasses}`} onClick={() => setIsFilterOpen(prev => !prev)}>
                    {isFilterOpen ? <OpenFilterIcon className="text-primary" /> : <DashboardFilterIcon className="ml-2! text-primary" />}
                    <span className="ml-2!">Filter</span>
                </div>
                {isFilterOpen && (
                    <div className={filterContentClasses}>
                        <div className="flex items-center">
                            <div className="flex items-center gap-2">
                                {filterConfig.status && (
                                    <div className="flex-shrink-0 w-30">
                                        <MultiSelectDropdown
                                            value={selectedStatus}
                                            onChange={setSelectedStatus}
                                            options={companyStatusOptions}
                                            placeholder="All Status"
                                        />
                                    </div>
                                )}
                                {filterConfig.tiers && (
                                    <div className="flex-shrink-0 w-25">
                                        <MultiSelectDropdown
                                            value={selectedTiers}
                                            onChange={setSelectedTiers}
                                            options={Constants.Dropdowns.Tier}
                                            placeholder="All Tier"
                                        />
                                    </div>
                                )}
                                {filterConfig.executive && (
                                    <div className="flex-shrink-0 w-50">
                                        <MultiSelectDropdown
                                            value={selectedAccountExecutive}
                                            onChange={setSelectedAccountExecutive}
                                            options={superAdmin}
                                            placeholder="All Account Executives"
                                        />
                                    </div>
                                )}
                                {filterConfig.companies && (
                                    <div className="flex-shrink-0 w-37.5">
                                        <CompaniesDropdown
                                            selectedCompanies={selectedCompanies}
                                            setSelectedCompanies={setSelectedCompanies}
                                            selectedTiers={selectedTiers}
                                            selectedStatus={selectedStatus}
                                            selectedAccountExecutive={selectedAccountExecutive}
                                        />
                                    </div>
                                )}
                                {filterConfig.dateRange && (<DateRangePicker
                                    defaultRange={selectedRange}
                                    onRangeChange={(ranges) => setSelectedRange({ ...ranges })}
                                />)}
                                {isAnyFilterApplied && (
                                    <span onClick={resetFilters} className={`${resetFilterClasses} flex items-center`}>
                                        <span className="mr-1! flex items-center"><ResetFilterIcon className="text-primary" /></span>
                                        Reset Filters
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CompanyFilters;
